import { render, staticRenderFns } from "./BiModalPackageNotPayable.vue?vue&type=template&id=ac4efdb2&"
import script from "./BiModalPackageNotPayable.vue?vue&type=script&lang=ts&"
export * from "./BiModalPackageNotPayable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports